<template>
    <div class="container-padded w-4/5 space-y-8 shadow-md sm:p-12">
        <h2>Features</h2>
        <ul class="list-disc">
            <li>All the "Free Pro" features PLUS</li>
            <li>Google Ads sponsored group advertising. Salesium targets local customers and gives your storefront higher search placement</li>
            <!--            <li>Third Party App Integration (coming soon!)</li>-->
        </ul>
        <ul>
            <li>$99/month</li>
            <li>$990/year (2 months free!)</li>
<!--            <li>30-day free trial for new subscribers</li>-->
        </ul>
    </div>
</template>

<script>
export default {
    props:["user"],
    name: "ProFeatures",
    methods: {

    }
}
</script>

<style scoped>

</style>
